export default __webpack_public_path__ + "static/media/1483.dcdca54f.png";